var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAcount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "url(#pattern0_3_1131)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_3_1131",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_3_1131",
    transform: "scale(0.0078125)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_3_1131",
    width: 128,
    height: 128,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAYAAADDPmHLAAAAAXNSR0IArs4c6QAAA5FJREFUeF7t3aF1FWEQR/F9DkUDaFQUEkcDSFwcJioV0AIlxOHSBB1wIlCcSBqggXCo4SfmDXvjJ+/b/3f3zmzeZvdy9/z0cgz+/L55pE9/8/MT1Wvx9vVfAsAQCADL79ge4Pb1Z4CTAxwAAdAQKAzUAiS942gGGL6KqQWcHOAACIBmAGGgGUDSawY4pv+SWQs4OcABEADNAMJAM4Ck1wzQDLD9DNq+/svHV1/ofoDpKVY3AAU2fgbr8QcAErD9BAiAAKgFCAMZYPjbLO2Bsvn/agMgAJQhqtcToBmA4s8A6xWI+7/++DMAEtAM0AyACFl5MwD+Z5HF3wywvgcGQN8FEAPNAM0ABJAWNwM0AxBDXQZSfP/BEPj1/T3dD/Dr22eKUBVGH34FxTpDvL19oKO4BADlx8UBMNzDeQfxFwRAABBCtQCKb744A2QAojADUHzzxRkgAxCFGYDimy/OABmAKMwAFN98cQbIAERhBqD45oszQAYgCjMAxTdfnAEyAFHIBph+PoDeD6BnEKV/BU840fzG7wjSAwgAe+FGAKACpgHWzw+AAJh9QIQSXAuoBeA5bOXTAOvn1wJs/8ffdxAAy/8zSVtYAAQAOawWQPHNv/ImA2QAQjgDUHwZgB8QoQrTIQr3v6sA3YAAsJdfa361AFSAbsD0CRQAATD7XQDmf/pyNdC4AU6/gxhAAGCA28sDYPsO4voDAAPcXh4A23cQ1x8AGOD28gDYvoO4/gDAALeXB8D2HcT1BwAGuL08ALbvIK4/ADDA7eUBsH0Hcf0BgAFuLw+A7TuI6x8H4MO7P3QI+r4B+vArKNYHPHz/8ZqOgu8HCADK/wgAfOOIxT9fHQABQBTWAii++eIMkAGIwgxA8c0XZ4AMQBRmAIpvvjgDZACiMANQfPPFGSADEIUZgOKbL84AGYAozAAU33xxBsgARCEb4O756UVWoDck6BMyZO3XUDud3yUAZjEIgOHn/M1u//xj5jLAMAEZIAMQgjpDZQCK34szQAYgijIAxTdfnAEyAFGYASi++eIMkAGIwgxA8c0XZ4AMQBRmAIpvvjgDZACiMANQfPPFGQANoHfUKAL6fIMACABi8PQtIAPYS6fWfxsYAAFACtXiZoCbR8pQe1gGyAAEoBZngAxADHUZ2GUgAaQttKsAiv84agG1AEKoFlALIIBqAbcPFKAW1wJqAcRQLaAWQADVAmoBBNBfRwlb3T0COUYAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcount);
export default __webpack_public_path__ + "static/media/acount.56fc2ce35aba7e5dd5ddde847e86df36.svg";
export { ForwardRef as ReactComponent };